import { normalizeValue } from '@dte/otw-utils-core/src/strings/normalizeValue';

export function safeParseURL(url: URL | string | undefined): string | undefined {
	// Value is already a URL
	if (url instanceof URL) {
		return url.toString();
	}

	const urlString = normalizeValue(url);
	if (!urlString) {
		return undefined;
	}

	try {
		const urlValue = new URL(urlString);
		return urlValue?.toString();
	} catch {
		// Unable to parse URL
	}

	return undefined;
}
